import React, { useState, useEffect } from 'react';
import { Users, UserPlus, 
  Scale, FileText, Building,  Shield, Briefcase, 
  Globe, Award, Home, Zap, Target, Crown, Star, 
  ArrowRight, Sparkles, Heart, 
  BookOpen, Gavel, HandHeart, TrendingUp, Coffee,
  ExternalLink, MessageSquare, GraduationCap, Phone
} from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MainServicesPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredService, setHoveredService] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const whatsappUrl = "https://wa.me/966115115945";

  const services = [
    {
      id: 1,
      icon: MessageSquare,
      title: "الاستشارات القانونية",
      description: "استشارات متخصصة في جميع المجالات القانونية مع فريق من الخبراء المعتمدين",
      category: "consulting",
      features: ["الاستشارة الفورية", "التحليل القانوني", "التوجيه القانوني"],
      route: "/LegalConsultation"
    },
    {
      id: 2,
      icon: Gavel,
      title: "التمثيل القضائي والتقاضي",
      description: "تمثيل وترافع في جميع أنواع القضايا أمام المحاكم المختلفة",
      category: "judicial",
      features: ["التمثيل القانوني", "الترافع القضائي", "متابعة الإجراءات"],
      route: "/JudicialRepresentation"
    },
    {
      id: 3,
      icon: FileText,
      title: "صياغة العقود والمستندات القانونية",
      description: "إعداد ومراجعة جميع أنواع العقود والمستندات القانونية باحترافية عالية",
      category: "contracts",
      features: ["إعداد العقود", "مراجعة العقود", "صياغة المستندات"],
      route: "/ContractDrafting"
    },
    {
      id: 4,
      icon: Scale,
      title: "تقسيم الثروات",
      description: "خدمات تقسيم وتوزيع الثروات والممتلكات وفقاً للقانون",
      category: "wealth",
      features: ["توزيع التركات", "تقسيم الممتلكات", "إدارة الأصول"],
      route: "/WealthDistribution"
    },
    {
      id: 5,
      icon: Heart,
      title: "التمثيل القانوني أمام محاكم الأحوال الشخصية",
      description: "حلول شاملة لقضايا الأسرة والزواج والطلاق والحضانة",
      category: "family",
      features: ["قضايا الحضانة", "الأحوال الشخصية"],
      route: "/FamilyLaw"
    },
    {
      id: 6,
      icon: Gavel,
      title: "التمثيل القانوني أمام المحاكم العامة",
      description: "تمثيل قانوني شامل أمام جميع المحاكم العامة بكافة درجاتها",
      category: "courts",
      features: ["القضايا الجنائية", "القضايا التجارية", "القضايا الإدارية"],
      route: "/GeneralCourts"
    },
    {
      id: 7,
      icon: Building,
      title: "الشركات",
      description: "خدمات متكاملة لتأسيس وإدارة الشركات بكافة أنواعها",
      category: "corporate",
      features: ["إدارة الموارد البشرية", "التعامل مع الجهات الحكومية", "إدارة الحوكمة"],
      route: "/Corporates"
    },
    {
      id: 8,
      icon: Building,
      title: "العمل والعمال",
      description: "حل النزاعات المتعلقة بالعمل والعمال والمنازعات المهنية",
      category: "labor",
      features: ["قضايا العمل", "النزاعات العمالية", "المنازعات المهنية"],
      route: "/WorkAndLabor"
    },
    {
      id: 9,
      icon: Shield,
      title: "حماية حقوق الملكية الفكرية",
      description: "حماية وتسجيل العلامات التجارية والملكية الفكرية",
      category: "intellectual",
      features: ["تسجيل العلامة", "حماية الملكية", "متابعة الطلبات"],
      route: "/IntellectualProperty"
    },
    {
      id: 10,
      icon: UserPlus,
      title: "الحلول البديلة لفض المنازعات",
      description: "حل النزاعات عبر الوساطة والصلح خارج المحاكم",
      category: "mediation",
      features: ["الوساطة التجارية", "الوساطة العائلية", "الحلول السلمية"],
      route: "/AlternativeDisputeResolution"
    },
    {
      id: 11,
      icon: Shield,
      title: "تحصيل الديون",
      description: "خدمات تحصيل الديون وتسوية المديونيات بطرق قانونية متخصصة",
      category: "debt",
      features: ["التسوية الودية", "التسوية القضائية", "التنفيذ الجبري"],
      route: "/debt-collection"
    },
    {
      id: 12,
      icon: FileText,
      title: "خدمات التوثيق",
      description: "خدمات توثيق شاملة تضمن صحة وموثوقية جميع الوثائق القانونية",
      category: "notarization",
      features: ["إفراغ صكوك الملكية", "الوكالات والرهن", "عقود الشركات"],
      route: "/notarization-services"
    },
    {
      id: 13,
      icon: Globe,
      title: "خدمات الاستثمار الأجنبي",
      description: "تسهيل وتنظيم الاستثمارات الأجنبية والشراكات الدولية",
      category: "investment",
      features: ["التراخيص الاستثمارية", "الشراكات الأجنبية", "الامتثال القانوني"],
      route: "/ForeignInvestment"
    },
    {
      id: 14,
      icon: Shield,
      title: "منازعات التأمين",
      description: "تقديم الاستشارات المتعلقة بعقود التأمين والتعامل مع القضايا التأمينية",
      category: "insurance",
      features: ["إدارة النزاعات التأمينية", "مراجعة وصياغة العقود", "التمثيل القانوني"],
      route: "/insurance-disputes"
    },
    {
      id: 15,
      icon: FileText,
      title: "لوائح تنظيم العمل",
      description: "إعداد واعتماد لوائح تنظيم العمل للشركات والمؤسسات",
      category: "work_regulations",
      features: ["لوائح نموذجية", "لوائح مخصصة", "تحديث وتطوير"],
      route: "/work-regulations"
    },
    {
      id: 16,
      icon: Globe,
      title: "التجارة الإلكترونية",
      description: "الحماية القانونية لمشروعك التجاري الإلكتروني وتراخيصه المطلوبة",
      category: "ecommerce",
      features: ["مشاريع التجارة الإلكترونية", "تحويل المشروع للتجارة الإلكترونية", "التسجيل في منصة الأعمال"],
      route: "/Ecommerce"
    },

  ];





  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100" dir="rtl">
      
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div className="relative py-12 sm:py-16 overflow-hidden mt-16 sm:mt-20 bg-cover bg-center bg-fixed" style={{ backgroundImage: 'url("/images/services/hero sec services.png")' }}>
        {/* Dark overlay */}
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(10, 58, 35, 0.8)' }}></div>
        
        {/* Subtle Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-48 h-48 sm:w-96 sm:h-96 rounded-full mix-blend-multiply filter blur-xl animate-pulse" style={{ backgroundColor: '#0a3a23' }}></div>
          <div className="absolute top-10 sm:top-20 right-10 sm:right-20 w-40 h-40 sm:w-80 sm:h-80 rounded-full mix-blend-multiply filter blur-xl animate-pulse" style={{ backgroundColor: '#0a3a23', animationDelay: '2s' }}></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
          <div 
            className={`transform transition-all duration-1000 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
            }`}
          >
            {/* Badge */}
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-white/10 backdrop-blur-lg border border-white/20 rounded-full px-4 sm:px-6 py-2 sm:py-3 mb-4 sm:mb-6">
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
              <span className="text-white font-bold text-xs sm:text-sm">الخدمات القانونية المتخصصة</span>
            </div>
            
            {/* Main Title */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 leading-tight">
              خدماتنا القانونية المتميزة
            </h1>
            
            {/* Subtitle */}
            <p className="text-base sm:text-lg md:text-xl opacity-90 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed mb-6 sm:mb-8 px-4">
              نقدم مجموعة شاملة من الخدمات القانونية المتخصصة لحماية حقوقك ومصالحك مع فريق من الخبراء المعتمدين
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center items-center mb-6 sm:mb-8 px-4">
              <a
                href="#services"
                className="inline-flex items-center gap-2 sm:gap-3 text-white px-6 sm:px-8 py-3 rounded-full font-bold text-sm sm:text-base transition-all duration-300 shadow-lg hover:shadow-white/25 hover:scale-105 cursor-pointer w-full sm:w-auto"
                style={{ backgroundColor: '#0a3a23' }}
                onClick={() => console.log('Scrolling to services')}
              >
                <Target className="w-4 h-4 sm:w-5 sm:h-5" />
                استكشف خدماتنا
              </a>
              
              <a
                href={`${whatsappUrl}?text=أريد الاستفسار عن خدماتكم القانونية`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 sm:gap-3 bg-white/10 backdrop-blur-lg border-2 border-white/30 text-white px-6 sm:px-8 py-3 rounded-full font-bold text-sm sm:text-base hover:bg-white/20 transition-all duration-300 cursor-pointer w-full sm:w-auto"
                onClick={() => console.log('Opening WhatsApp')}
              >
                <WhatsAppIcon className="w-4 h-4 sm:w-5 sm:h-5" />
                تواصل معنا الآن
              </a>
            </div>


          </div>
        </div>
      </div>



      {/* Services Grid */}
      <div id="services" className="py-12 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-20">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-8">
              خدماتنا المتخصصة
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto px-4">
              اكتشف مجموعة واسعة من الخدمات القانونية المصممة لتلبية جميع احتياجاتك
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`group relative transform transition-all duration-700 hover:scale-105 ${
                  isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
                onMouseEnter={() => setHoveredService(service.id)}
                onMouseLeave={() => setHoveredService(null)}
              >
                <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 overflow-hidden h-full hover:shadow-xl transition-all duration-500 flex flex-col mx-1 sm:mx-2">
                  {/* Header with gradient */}
                  <div className="p-4 sm:p-6 lg:p-8 text-white relative overflow-hidden flex-shrink-0" style={{ backgroundColor: '#0a3a23' }}>
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-10">
                      <div className="absolute top-0 right-0 w-12 h-12 sm:w-16 sm:h-16 lg:w-24 lg:h-24 bg-white rounded-full -translate-y-6 sm:-translate-y-8 lg:-translate-y-12 translate-x-6 sm:translate-x-8 lg:translate-x-12"></div>
                      <div className="absolute bottom-0 left-0 w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 bg-white rounded-full translate-y-4 sm:translate-y-6 lg:translate-y-8 -translate-x-4 sm:-translate-x-6 lg:-translate-x-8"></div>
                    </div>
                    
                    <div className="relative z-10 text-center w-full">
                      {/* Icon */}
                      <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-white/20 backdrop-blur-lg rounded-xl sm:rounded-2xl flex items-center justify-center mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                        <service.icon className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 text-white" />
                      </div>
                      
                      {/* Title */}
                      <h3 className="text-lg sm:text-xl font-bold">{service.title}</h3>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-4 sm:p-6 lg:p-8 flex-1 flex flex-col">
                    {/* Description */}
                    <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-xs sm:text-sm">{service.description}</p>
                    
                    {/* Features */}
                    <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8 flex-1">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2 sm:gap-3">
                          <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full flex-shrink-0" style={{ backgroundColor: '#0a3a23' }}></div>
                          <span className="text-gray-700 text-xs sm:text-sm">{feature}</span>
                        </div>
                      ))}
                    </div>

                    {/* Buttons */}
                    <div className="space-y-2 sm:space-y-3 mt-auto">
                      {/* اقرأ المزيد Button */}
                      <Link
                        to={service.route}
                        className="w-full inline-flex items-center justify-center gap-2 sm:gap-3 text-white px-4 sm:px-6 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold hover:shadow-lg transition-all duration-300 group-hover:scale-105 cursor-pointer select-none z-10 relative text-sm sm:text-base"
                        style={{ backgroundColor: '#0a3a23' }}
                        onClick={() => console.log('Navigating to:', service.route)}
                      >
                        <BookOpen className="w-4 h-4 sm:w-5 sm:h-5" />
                        اقرأ المزيد
                        <ExternalLink className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform duration-300" />
                      </Link>
                      
                      {/* اطلب الخدمة Button */}
                      <a
                        href={`${whatsappUrl}?text=أريد الاستفسار عن ${service.title}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full inline-flex items-center justify-center gap-2 sm:gap-3 bg-white border-2 px-4 sm:px-6 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold hover:bg-gray-50 transition-all duration-300 cursor-pointer select-none z-10 relative text-sm sm:text-base"
                        style={{ borderColor: '#0a3a23', color: '#0a3a23' }}
                        onClick={() => console.log('Opening WhatsApp for:', service.title)}
                      >
                        <WhatsAppIcon className="w-4 h-4 sm:w-5 sm:h-5" />
                        اطلب الخدمة
                        <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform duration-300" />
                      </a>
                    </div>
                  </div>

                  {/* Hover Effect */}
                  {hoveredService === service.id && (
                    <div className="absolute inset-0 rounded-2xl sm:rounded-3xl animate-pulse" style={{ backgroundColor: 'rgba(10, 58, 35, 0.1)' }}></div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href={`${whatsappUrl}?text=أريد استشارة في الخدمات القانونية`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MainServicesPage; 
